/* eslint-disable import/prefer-default-export */
import apiClient from '../utilities/api-client';

export const getAgronomicDates = async () => apiClient.get(`/agronomic_dates`);
